import Repository from "./Repository";
import router from "../router";

const resource = "/Auth";

export default {
  login(data) {
    return Repository.post(`${resource}/login`, data)
      .then((response) => {
        router.push({ path: "/" });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  userInfo() {
    return Repository.get(`${resource}/current-user`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
